/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Notes {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description Create a new note
   *
   * @tags Notes
   * @name CreateNote
   * @summary Create Note
   * @request POST:/api/notes
   * @secure
   */
  createNote = (data, params = {}) =>
    this.http.request({
      path: `/api/notes`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get all notes for a specific entity
   *
   * @tags Notes
   * @name ListNotesForEntity
   * @summary List Notes For Entity
   * @request GET:/api/notes
   * @secure
   */
  listNotesForEntity = (query, params = {}) =>
    this.http.request({
      path: `/api/notes`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a note by ID
   *
   * @tags Notes
   * @name GetNote
   * @summary Get Note
   * @request GET:/api/notes/{note_id}
   * @secure
   */
  getNote = (noteId, params = {}) =>
    this.http.request({
      path: `/api/notes/${noteId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update a note (only creator can update)
   *
   * @tags Notes
   * @name UpdateNote
   * @summary Update Note
   * @request PUT:/api/notes/{note_id}
   * @secure
   */
  updateNote = (noteId, data, params = {}) =>
    this.http.request({
      path: `/api/notes/${noteId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a note (only creator can delete)
   *
   * @tags Notes
   * @name DeleteNote
   * @summary Delete Note
   * @request DELETE:/api/notes/{note_id}
   * @secure
   */
  deleteNote = (noteId, params = {}) =>
    this.http.request({
      path: `/api/notes/${noteId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Get all direct replies for a note
   *
   * @tags Notes
   * @name GetRepliesForNote
   * @summary Get Replies For Note
   * @request GET:/api/notes/{note_id}/replies
   * @secure
   */
  getRepliesForNote = (noteId, params = {}) =>
    this.http.request({
      path: `/api/notes/${noteId}/replies`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Add a reaction to a note
   *
   * @tags Notes
   * @name AddReaction
   * @summary Add Reaction
   * @request POST:/api/notes/{note_id}/reactions
   * @secure
   */
  addReaction = (noteId, data, params = {}) =>
    this.http.request({
      path: `/api/notes/${noteId}/reactions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Remove a reaction from a note
   *
   * @tags Notes
   * @name RemoveReaction
   * @summary Remove Reaction
   * @request DELETE:/api/notes/{note_id}/reactions/{emoji}
   * @secure
   */
  removeReaction = (noteId, emoji, params = {}) =>
    this.http.request({
      path: `/api/notes/${noteId}/reactions/${emoji}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}
